var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen flex-column",attrs:{"data-theme":"greenDark"}},[_c('Header',{attrs:{"title":"卓创资讯炼油行业运行监测系统"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }